import { StoreAction, XmAction } from 'store/actions';
import { InternationalRate } from './models';

export function internationalRateReducer(state: InternationalRate[] = [], action: XmAction<InternationalRate[]>): InternationalRate[] {
    switch (action.type) {
        case StoreAction.GET_INTERNATIONAL_RATES:
            return action.payload;
        default:
            return state;
    }
}
